import { Box, Image } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import Map from '../../assets/images/minimap.png';
import Point from '../../assets/images/minimap_point.png';
import { MinimapProps } from '../../interfaces/components';

const Minimap = ({ activeScene }: MinimapProps) => {
  const [top, setTop] = useState<string>('170px');
  const [left, setLeft] = useState<string>('70px');

  // eslint-disable-next-line
  const locations: any = {
    lr_exterior_0: { top: '170px', left: '70px' },
    lr_exterior_1: { top: '160px', left: '80px' },
    lr_exterior_2: { top: '165px', left: '62px' },
    lr_exterior_3: { top: '150px', left: '62px' },
    lr_exterior_4: { top: '145px', left: '80px' },
    lr_exterior_5: { top: '140px', left: '74px' },
    lr_exterior_6: { top: '145px', left: '60px' },
    lr_exterior_7: { top: '145px', left: '60px' },
    lr_exterior_8: { top: '145px', left: '55px' },
    lr_exterior_9: { top: '140px', left: '80px' },
    lr_exterior_10: { top: '140px', left: '85px' },
    lr_exterior_11: { top: '135px', left: '73px' },
    lr_exterior_12: { top: '125px', left: '75px' },
    lr_exterior_13: { top: '125px', left: '70px' },
    lr_exterior_14: { top: '115px', left: '75px' },
    lr_exterior_15: { top: '115px', left: '70px' },
    lr_exterior_16: { top: '113px', left: '70px' },
    lr_exterior_17: { top: '100px', left: '55px' },
    lr_exterior_18: { top: '100px', left: '47px' },
    lr_exterior_19: { top: '100px', left: '38px' },
    lr_exterior_20: { top: '95px', left: '38px' },
    lr_exterior_21: { top: '90px', left: '38px' },
    lr_exterior_22: { top: '85px', left: '42px' },
    lr_exterior_23: { top: '85px', left: '50px' },
    lr_exterior_24: { top: '85px', left: '55px' },
    lr_exterior_25: { top: '85px', left: '60px' },
    lr_exterior_26: { top: '85px', left: '70px' },
    lr_exterior_27: { top: '85px', left: '75px' },
    lr_exterior_28: { top: '90px', left: '85px' },
    lr_exterior_29: { top: '97px', left: '85px' },
    lr_exterior_30: { top: '97px', left: '90px' },
    lr_exterior_31: { top: '97px', left: '97px' },
    lr_exterior_32: { top: '95px', left: '100px' },
    lr_exterior_33: { top: '85px', left: '95px' },
    lr_exterior_34: { top: '80px', left: '105px' },
    lr_exterior_35: { top: '80px', left: '105px' },
    lr_exterior_36: { top: '97px', left: '110px' },
    lr_exterior_37: { top: '90px', left: '110px' },
    lr_exterior_38: { top: '85px', left: '110px' },
    lr_exterior_39: { top: '65px', left: '95px' },
    lr_exterior_40: { top: '65px', left: '105px' },
    lr_exterior_41: { top: '65px', left: '114px' },
    lr_exterior_42: { top: '50px', left: '97px' },
    lr_exterior_43: { top: '50px', left: '114px' },
    lr_exterior_44: { top: '40px', left: '114px' },
    lr_exterior_45: { top: '40px', left: '105px' },
    lr_exterior_46: { top: '40px', left: '97px' },
    lr_exterior_47: { top: '35px', left: '97px' },
    lr_exterior_48: { top: '30px', left: '97px' },
    lr_exterior_49: { top: '30px', left: '105px' },
    lr_exterior_50: { top: '40px', left: '115px' },
  };

  const updatePointerLocation = (sceneName: string) => {
    const location = locations[sceneName];
    if (location) {
      setTop(location.top);
      setLeft(location.left);
    } else {
      //Default for Appartment
      setTop('15px');
      setLeft('105px');
    }
  };

  useEffect(() => {
    // window.updatePointerLocation = updatePointerLocation;
    if (activeScene && activeScene !== 'room-1') {
      updatePointerLocation(activeScene);
    }
  }, [activeScene]);

  return (
    <Box position="relative">
      <Image src={Map} w="160px" objectFit="contain" alt="minimap" />
      <Box position="absolute" top={top} left={left}>
        <Image src={Point} w="10px" objectFit="contain" alt="point" />
      </Box>
    </Box>
  );
};

export default Minimap;
